import { render, staticRenderFns } from "./ScoreViewer.vue?vue&type=template&id=87c02b66&scoped=true&"
import script from "./ScoreViewer.vue?vue&type=script&lang=js&"
export * from "./ScoreViewer.vue?vue&type=script&lang=js&"
import style0 from "./ScoreViewer.vue?vue&type=style&index=0&id=87c02b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c02b66",
  null
  
)

export default component.exports